import { scoreColor } from "@/lib/api";

export const ScoreGauge = ({ score, size = 200 }) => {
  const c = scoreColor(score);
  const radius = size / 2 - 14;
  const circumference = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, score || 0));
  const offset = circumference - (pct / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="score-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E4E4E7" strokeWidth="12" />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={c.hex} strokeWidth="12"
          strokeLinecap="butt" strokeDasharray={circumference} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1.2s cubic-bezier(0.16,1,0.3,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-heading font-black tracking-tighter leading-none" style={{ color: c.hex, fontSize: size * 0.34 }}>
          {score ?? "—"}
        </span>
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase mt-1" style={{ color: c.hex }}>{c.label}</span>
      </div>
    </div>
  );
};
